module.exports = __webpack_public_path__ + "static/media/aalto_logo_500.844d66e7.png";